import { apiFetch, type ApiResponse } from "./fetch";

type BlogArticleDto = {
	content: unknown[];
	createdAt: string;
	excerpt: string;
	id: string;
	slug: string;
	title: string;
	updatedAt: string;
};

export type BlogArticleInput = {
	content: unknown[];
	excerpt: string;
	slug: string;
	title: string;
};

type BlogArticlePageDto = {
	hasMore: boolean;
	items: BlogArticleDto[];
};

export const getApiBlog = ({ limit = 12, offset = 0 }: { limit?: number; offset?: number } = {}) =>
	apiFetch<ApiResponse<BlogArticlePageDto>>({
		method: "GET",
		query: { limit, offset },
		uri: "blog",
	});

export const getApiBlogById = ({ id }: { id: string }) =>
	apiFetch<ApiResponse<BlogArticleDto>>({ method: "GET", uri: `blog/${id}` });

export const postApiBlog = (data: BlogArticleInput) =>
	apiFetch<ApiResponse<BlogArticleDto>>({ body: data, method: "POST", uri: "blog" });

export const putApiBlogById = ({ id }: { id: string }, data: BlogArticleInput) =>
	apiFetch<ApiResponse<null>>({ body: data, method: "PUT", uri: `blog/${id}` });

export const deleteApiBlogById = ({ id }: { id: string }) =>
	apiFetch<ApiResponse<null>>({ method: "DELETE", uri: `blog/${id}` });
